import moment from 'moment'
export const config = {
  // tableType:'antd',
  rowSelection: false,
  columns: [
    {
      title: '订单号',
      dataIndex: 'orderNo',
      width: 180,
      render: 'SIDRender',
      fixed: 'left',
    },
    {
      title: '需求标签',
      dataIndex: 'bizTag',
      width: 100,
      render: 'bizTagRender',
    },
    {
      title: '客户姓名',
      dataIndex: 'customerName',
      width: 120,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '电话',
      dataIndex: 'customerPhone',
      width: 120,
    },
    {
      title: '订单金额（元）',
      key: 'totalPrice',
      dataIndex: 'totalPrice',
      width: 140,
    },
    {
      title: '商品名称',
      key: 'quoteGoodsList',
      dataIndex: 'quoteGoodsList',
      width: 240,
      render: (list: any) => <span>{ list?.map(item => item.name)?.join('，') || ''}</span>
    },
    {
      title: '服务地址',
      dataIndex: 'serviceAddress',
      width: 300,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '创建人',
      key: 'createdByName',
      dataIndex: 'createdByName',
      width: 100,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '创建时间',
      key: 'createdTime',
      dataIndex: 'createdTime',
      width: 180,
      ellipsis: {
        showTitle: true,
      },
      render: v => <span>{v ? moment(v).format('YYYY-MM-DD HH:mm:ss') : ''}</span>,
    },
    {
      title: '订单状态',
      dataIndex: 'status',
      width: 100,
      render: 'statusRender',
      fixed: 'right',
    },
    {
      title: '操作',
      dataIndex: 'actions',
      width: 130,
      render: 'actionRender',
      fixed: 'right',
    },
  ],
  search: [
    {
      label: '客户姓名',
      name: 'customerNameLike',
      type: 'input',
    },
    {
      label: '电话',
      name: 'customerPhone',
      type: 'input',
    },
    {
      label: '创建人',
      type: 'input',
      name: 'createdNameByLike',
    },
    {
      label: '订单号',
      type: 'input',
      name: 'orderNo',
    },
    {
      label: '线索ID',
      type: 'input',
      name: 'clueId',
    },
    {
      label: '商机ID',
      type: 'input',
      name: 'trackId',
    },
    {
      label: '合同号',
      type: 'input',
      name: 'contractNo',
    },
    {
      label: '需求标签',
      name: 'bizTag',
      itemType: 'select',
      data: 'bizOpTypeEnum',
      labelKey: 'description',
      key: 'key',
    },
  ],
  footer: [
    {
      label: '去做报价',
      type: 'primary',
      events: ['onClick:clickToOrder'],
    },
  ],
  batchActions: [],
}
